<template>
  <div class="w-50 mx-auto">
    <div class="page-title my-3">
      <mdb-icon  icon="sign-in-alt" /> 회원가입 <small>/ 훈련 기관 선택</small>
    </div>
    <div v-for="org in orgs" :key="org._id" class="pointer ml-4" @click="onNext(org)">
      <mdb-icon  icon="graduation-cap" /> {{org.name}} <mdb-icon  icon="external-link-alt" />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'JoinOrg',
  data: () => ({
    orgs: []
  }),
  computed: {
  },
  methods: {
    ...mapMutations('auth', ['setOrg']),
    onNext (org) {
      this.$router.push({ name: 'JoinPhoneAuth', params: { org: org.prefix } })
    },
    async load () {
      this.orgs = await this.$Org.list()
    }
  },
  created () { this.load() }
}
</script>
